import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';

@Component({
  selector: 'lib-zoho-widget-form',
  templateUrl: './zoho-widget-form.component.html',
  styleUrls: ['./zoho-widget-form.component.css'],
  standalone: false
})
export class ZohoWidgetFormComponent implements AfterViewInit {
  ngAfterViewInit(): void {}
}
